import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//培训列表
export const getTrainList = data => http.get('/mini/Train', data);

//培训详情
export const getTrainDetail = data => http.get('/mini/Train/' + data.uuid);

//培训分类列表
export const getTrainCate = data => http.get('/mini/TrainCate');

//下单
export const getTrainOrder = data => http.post('/mini/TrainOrder',data);

//培训订单详情
export const getTrainOrderDetail = data => http.get('/mini/TrainOrder/'+data.uuid);

//培训订单列表
export const getTrainOrderList = data => http.get('/mini/TrainOrder',data);